export const changeRegisterMode = (state) => {
    return { type: 'CHANGE_REGISTER_MODE', payload: state }
}